///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, computed, input } from '@angular/core';
import { GtthHistoryService } from '../../logical-topology/engine/history-service';
import { E2eTestUtils } from '../../../../testing/e2e-test-utils';
import { SuiTooltipDirective, TooltipPosition } from '@siklu/sui-lib/infrastructure';

export interface PointerConfig {
    separateBy?: string;
    placement?: TooltipPosition;
    nodeNames?: string;
    cropName?: number;
}

@Component({
    selector: 'winde-node-pointer',
    imports: [SuiTooltipDirective],
    template: `
        @for (node of nodeNamesList(); track node) {
            <span class="node-link-item" [attr.data-after]="listData().separateBy">
                <a
                    class="btn btn-link no-padding align-baseline btn--node-link btn--node-link-{{ $index }}"
                    tabindex="1"
                    style="color: #3e8acc"
                    [attr.data-node-name]="node"
                    suiTooltip
                    [showDelay]="2000"
                    [tooltipText]="node"
                    [position]="listData().placement"
                    [disabled]="tooltipsAreDisabled"
                    (click)="showNodeOnMap(node)"
                >
                    {{ cropNodeName(node) }}
                </a>
            </span>
        }
    `
})
export class GtthNodePointerComponent {
    public readonly tooltipsAreDisabled = E2eTestUtils.isTooltipsDisabled();

    listData = input<PointerConfig>();
    nodeNamesList = computed(() => {
        if (this.listData().separateBy) {
            return this.listData().nodeNames.split(this.listData().separateBy);
        } else {
            return [this.listData().nodeNames];
        }
    });

    constructor(private readonly historyService: GtthHistoryService) {}

    cropNodeName(nodeName: string): string {
        if (this.listData().cropName && nodeName && nodeName.length > this.listData().cropName + 3) {
            return nodeName.substring(0, this.listData().cropName - 1) + '...';
        } else {
            return nodeName;
        }
    }

    showNodeOnMap(nodeName: string): void {
        const position = this.historyService.logicalTopology.getStationByName(nodeName)?.getPosition();

        if (position) {
            this.historyService.mapSetCenterAndZoom(position.toLatLngLiteral().lat, position.toLatLngLiteral().lng);

            this.historyService.ngZone.runOutsideAngular(() => {
                this.historyService.addSearchMarker(position.toLatLngLiteral(), nodeName + ' pointer');
            });
        }
    }
}
